import { render, staticRenderFns } from "./DTCV2.vue?vue&type=template&id=3fa3691a"
import script from "./DTCV2.vue?vue&type=script&lang=js"
export * from "./DTCV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports